import http from "../../rest/http";
import { readFromLocalStorage } from "../../utils/DataEncryption";


export const fetchUsersDetails = async (userId: string) => {
  try {
    const response = await http.get(`/api/v1/user/${userId}`);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const updateUserDetails = async (data: any) => {
  try {
    const response = await http.post(`/api/v1/user/update-user`, data, "multipart/form-data");
    return response;
  } catch (error) {
    console.error("Error in updating users:", error);
    throw error;
  }
};

export const registerUserDetails = async (data: any) => {
  try {
    console.log("data in registerUse slice", data,readFromLocalStorage("appId"));
    const response = await http.post(`/api/v1/dynamic-forms/register`, data, "multipart/form-data");
    return response;
  } catch (error: any) {
    console.error("Error in registering users:", error);
    throw error?.response?.data?.errorMessage;
  }
};


export const deleteUser = async (userId: any) => {
  try {
    const response = await http.delete(`/api/v1/user/${userId}`);
    return response;
  } catch (error: any) {
    console.error("Error in deleting users:", error);
    throw error?.response?.data?.errorMessage;
  }
};

export const updateUserStatus = async (data: any) => {
  try {
    const response = await http.post(`/api/v1/user/change-status`, data);
    return response;
  } catch (error: any) {
    console.log('Error in updating user status:', error);
    throw error?.response?.data?.errorMessage;
  }
};

export const verifyPrimaryPhonenumber = async (phoneNumber: string) => {
  try {
    const response = await http.get(`/api/v1/user/verify-phone-exists/${phoneNumber}`);
    return response;
  } catch (error) {
    console.error("Error fetching phonenumber:", error);
    throw error;
  }
};

export const verifyFaceRecognition = async (data: any) => {
  try {
    const response = await http.post(`/api/v1/user/verify-face-exists`, data, "multipart/form-data");
    if (response.message == "Same Dealer") {
      const error = {
        "response": {
          "data": {
            "errorMessage": "Face already exists"
          }
        }
      }
      throw error
    }
    return response;
  } catch (error: any) {
    console.error("error in fetching face image:", error);
    throw error?.response?.data?.errorMessage;
  }
};

export const fetchTrainingCertificateList = async () => {
  try {
    const response = await http.get(`/api/v1/user/trainings-certifications  `);
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

export const verifyStaff = async (data: any) => {
  try {
    const response = await http.post(`/api/v1/user/ekyc/verify`, data);
    return response;
  } catch (error) {
    console.error("Error in verifying staff", error);
    throw error;
  }
};

export const resendConsentLink = async (userId: any) => {
  try {
    const response = await http.post(`/api/v1/user/send-consent?userId=${userId}`,{});
    return response;
  } catch (error) {
    console.error("Error in resend consent link staff", error);
    throw error;
  }
};
